import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PageNotFoundComponent } from './views/page-not-found/page-not-found.component';
import { AccessDeniedComponent } from './views/access-denied/access-denied.component';

const routes: Routes = [
    { 
        path: '',
        loadChildren: () => import('./views/landing/landing.module').then(m => m.LandingModule)
    },
    { 
        path: 'report-details/:moduleId/:reportId', 
        loadChildren: () => import('./views/report-details/report-details.module').then(m => m.ReportDetailsModule)
    },
    { path: 'authorization/:token', loadChildren: () => import('./views/authentication/authentication.module').then(m => m.AuthenticationModule) },
    { path: '404', title: '404', component: PageNotFoundComponent },
    { path: '403', title: '403', component: AccessDeniedComponent },
    { path: '**', redirectTo: '404' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true /*changed suresh, true added by Raghavender */})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
